module.exports = __webpack_public_path__ + "static/media/toolbar-main-tools.924fe398.svg";